import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { IncreaseOriginalValueMain } from './IncreaseOriginalValueMain'
import { IncreaseOriginalValueForm } from './IncreaseOriginalValueForm/IncreaseOriginalValueForm'

const increaseOriginalValueRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/increase-original-value',
    },
    component: <IncreaseOriginalValueMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/add',
    },
    component: (
      <IncreaseOriginalValueForm formMode="add" type="ASSETS_REGISTRATION" />
    ),
  },
]

export default increaseOriginalValueRoutes
